import React from 'react'
import { IconButton, styled, Typography, useTheme } from '@material-ui/core';
import * as coreSelectors from 'core/selectors';
import { connect } from 'react-redux'
import * as ServiceIcons from 'service/Icons';
import * as phoneSelectors from 'phone/selectors';
import * as phoneActions from 'phone/actions';
import PhoneIcon from '@material-ui/icons/Phone';
import PhoneDisabledIcon from '@material-ui/icons/PhoneDisabled';
import PhoneTalkIcon from '@material-ui/icons/PhoneInTalk';
import * as serviceActions from 'service/actions';
import { checkGrassHopper } from 'utils';

const ServiceButtonsContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))

function ServiceButtons({ user, phoneButtonRef, callState, setPhoneOpen, phoneOpen, openAssist, isMobile = false, buttonStyles = {} }) {
    let phoneIcon = <PhoneIcon color='inherit' />
    let phoneEnabled = true
    if (user.patchNumbers.length === 0 || checkGrassHopper(user)) {
        phoneIcon = <PhoneDisabledIcon color='inherit' />
        phoneEnabled = false;
    }
    if (callState === 'open') {
        phoneIcon = <PhoneTalkIcon color='inherit' />
    }
    const theme = useTheme()
    return (
        <ServiceButtonsContainer style={{ flexDirection: isMobile ? 'column' : 'row', }}>
            <IconButton onClick={() => { window.open("https://rubyhelpcenter.helpjuice.com/"); }}>
                <Typography variant='body2' style={{ fontFamily: 'Sofia', color: '#000', ...buttonStyles }}>Help Center</Typography>
            </IconButton>

            <IconButton style={{ color: theme.palette.secondary.main, ...buttonStyles }} onClick={openAssist} >
                <ServiceIcons.AssistIcon color='inherit' />
            </IconButton>

            <IconButton
                style={{ color: theme.palette.secondary.main, ...buttonStyles }}
                ref={phoneButtonRef}
                onClick={() => setPhoneOpen(!phoneOpen)}
                disabled={!phoneEnabled}>
                {phoneIcon}
            </IconButton>
        </ServiceButtonsContainer>
    )
}


const mapStateToProps = (state) => {
    return ({
        user: coreSelectors.getUser(state),
        callState: phoneSelectors.getCallState(state),
        phoneOpen: phoneSelectors.getPhoneOpen(state),
    });
};

const mapDispatchToProps = {
    setPhoneOpen: phoneActions.setPhoneOpen,
    openAssist: serviceActions.openAssist,
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceButtons);